




























import { Component, Vue, Watch } from 'vue-property-decorator'
import { RouteRecord } from 'vue-router'
// import {
//   home,
//   moment,
//   assessment,
//   application,
//   message,
//   manage,
//   teacherStudent,
//   setting,
// } from '@/router'
import { MessageController } from '@/services/request.service'
import { getRoleType } from '@/utils/utils'

@Component
export default class PadMenuLevel3 extends Vue {
  public newMessage = 0

  @Watch('$route', { immediate: true })
  public onRouteChanged(to: any, from: any) {
    this.getMessage()
  }

  public get subRoutes(): any {
    return this.$store.state.routes[0].children.filter(child => !child.hidden)
  }

  public get roleType(): string {
    return getRoleType()
  }

  public get routes(): Array<any> {
    const router = this.$route as any
    return router.matched.filter((item: RouteRecord) => item.meta && item.meta.routerName)
  }

  public get level3Menus(): Array<any> {
    if (this.routes.length >= 3) {
      if (this.routes[2].meta.showBack) {
        return []
      } else {
        return this.subRoutes
          .filter(route => route.name === this.routes[0].name)[0]
          .children.filter(child => child.name === this.routes[1].name)[0].children
      }
    } else {
      return []
    }
  }

  public getMessage(): void {
    MessageController.hasUnRead()
      .then(res => {
        if (res.data) {
          this.newMessage = 1
        } else {
          this.newMessage = 0
        }
      })
      .catch(err => {
        console.error(err)
      })
  }

  public selectLevel3({ key }: { key: string }): void {
    this.$router.push({ name: key }).catch(err => {})
  }
}
